import request from '../../utils/request';

export function createPricing(params) {
  const { companyId, ...rest } = params;
  return request(`/companies/${companyId}/pricing`, {
    method: 'POST',
    data: rest,
  });
}

export function getPricing(params) {
  const { companyId } = params;
  return request(`/companies/${companyId}/pricing`, {
    method: 'GET',
  });
}

export function updatePricing(params) {
  const { id, companyId, ...rest } = params;
  return request(`/companies/${companyId}/pricing/${id}`, {
    method: 'PATCH',
    data: rest,
  });
}

export function deletePricing(params) {
  const { id, companyId } = params;
  return request(`/companies/${companyId}/pricing/${id}`, {
    method: 'DELETE',
  });
}

export function deletePricingRange(params) {
  const { id, companyId, pricingId } = params;
  return request(`/companies/${companyId}/pricing/${pricingId}/pricingranges/${id}`, {
    method: 'DELETE',
  });
}
